export default class ItemDocumento {
    IdAuto: number;
    IdElemento: number;
    Clave: string;
    CodigoCliente: string;
    imgBase64: string;
    Imagen: string;
    PosicionGPS: string;
    Descargado: boolean;
    Descripcion: string;
    NombreArchivo: string;
    Extension: string;
    Size: string;
    EsFirma: boolean;
    fecDoc: string;

    constructor() {
        this.IdAuto = 0;
        this.IdElemento = 0;
        this.Clave = "";
        this.CodigoCliente = "";
        this.imgBase64 = "";
        this.Imagen = "";
        this.PosicionGPS = "";
        this.Descargado = false;
        this.Descripcion = "";
        this.NombreArchivo = "";
        this.Extension = "";
        this.Size = "";
        this.EsFirma = false;
        this.fecDoc = "";
    };
};
